/*
 * Copyright (C) 2018 - present by Potentially
 *
 * Please see distribution for license.
 */

import { InjectionToken } from '@angular/core';
import { ObservableResult } from '../../../shared/store';

export interface OutlookAuthUrlResponse {
  authUrl: string;
}

export interface OutlookStatusResponse {
  connected: boolean;
}

export interface OutlookDisconnectResponse {
  success: boolean;
  message: string;
}

export interface OutlookBulkSyncResponse {
  success: boolean;
  message: string;
}

export interface OutlookSyncEventResponse {
  success: boolean;
  message: string;
}

/** Injection token for the data service, used by angular to decide whether to inject Mock or API service at runtime. */
export const OUTLOOK_DATA_SERVICE = new InjectionToken<OutlookDataService>('[Outlook] DataService');

/** The outlook data service. */
export interface OutlookDataService {
  getAuthUrl(): ObservableResult<OutlookAuthUrlResponse>;

  getStatus(): ObservableResult<OutlookStatusResponse>;

  disconnect(): ObservableResult<OutlookDisconnectResponse>;

  syncAll(): ObservableResult<OutlookBulkSyncResponse>;

  syncEvent(eventId: string): ObservableResult<OutlookSyncEventResponse>;
}
